import React from "react";
import "../../../../../Assets/Styles/InactivityModal.scss";
import Vector from "../../../../../Assets/Images/Inactive.svg";
import {createPortal} from "react-dom";

const InactivityModal = (props) => {
  return createPortal(
    <div className="inactivity-modal-overlay">
      <section>
        <img alt="" src={Vector} />
        <h1>Your session has been ended due to inactivity.</h1>
        <button onClick={() => props.loginAgain()}>Login Again</button>
      </section>
    </div>, document.body
  );
};
export default InactivityModal;
